import CamExampleDrawing from "images/svgr/cam_example.svg";
import * as React from 'react';
export default {
  CamExampleDrawing,
  React
};